import Vue from 'vue';
import VueRouter from 'vue-router';
import store from "../store";

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Home.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue")
  },
  {
    path: "/map",
    name: "MapPage",
    component: () => import("@/views/MapPage.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/analytics",
    name: "Analytics",
    component: () => import("@/views/Analytics.vue")
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.loggedIn) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

export default router
